export const defaultState = {
  consultationId: null,
  chatMessages: [],
  doctorTyping: false,
  doctorTypingId: null,
  chatChannel: null,
  chatName: null,
  chatIcon: null,
  chatSubtitle: null,
  receiverId: null,
  consultationSummary: null,
};

// Dedupe by messageId, then order by timetoken so the list stays chronological
// regardless of how messages were merged in. This matters because messages
// arrive from two sources with different ordering: realtime/optimistic adds
// append to the end, while polled history() prepends a fresh page. Without a
// stable sort, polling strands out-of-window messages in the wrong place.
// In-flight messages that don't have a timetoken yet (just sent, awaiting the
// publish ack) sort last, since they are the newest.
const dedupeAndSortMessages = (messages) =>
  messages
    .filter(
      (message, index, self) =>
        index === self.findIndex((t) => t.messageId === message.messageId)
    )
    .map((message, index) => ({ message, index }))
    .sort((a, b) => {
      const ta = a.message.timetoken == null ? Infinity : a.message.timetoken;
      const tb = b.message.timetoken == null ? Infinity : b.message.timetoken;
      // Fall back to insertion order for equal timetokens (stable sort).
      return ta === tb ? a.index - b.index : ta - tb;
    })
    .map(({ message }) => message);

export default function chat(state = defaultState, action) {
  switch (action.type) {
    case 'SET_CHAT_INFO':
      return Object.assign({}, state, {
        consultationId: action.payload.consultationId || state.consultationId,
        chatChannel: action.payload.chatChannel || state.chatChannel,
        chatName: action.payload.chatName || state.chatName,
        chatIcon: action.payload.chatIcon || state.chatIcon,
        chatSubtitle: action.payload.chatSubtitle || state.chatSubtitle,
        receiverId: action.payload.receiverId || state.receiverId,
      });
    case 'SET_CHAT_MESSAGES':
      return Object.assign({}, state, {
        chatMessages: dedupeAndSortMessages([...action.payload.chatMessages]),
      });
    case 'ADD_CHAT_MESSAGE':
      return Object.assign({}, state, {
        chatMessages: dedupeAndSortMessages(
          state.chatMessages.concat([action.payload.chatMessage])
        ),
      });
    case 'RESET_CHAT':
      return Object.assign({}, state, defaultState);
    case 'SET_CONSULTATION_SUMMARY':
      return Object.assign({}, state, {
        consultationSummary: action.payload,
      });
    case 'SET_DOCTOR_TYPING':
      return Object.assign({}, state, {
        doctorTyping: action.payload.typing,
        doctorTypingId: action.payload.doctorId,
      });
    case 'SET_INITIAL_STATE':
      return { ...defaultState };
    case 'SET_CONSULTATION_ID':
      return Object.assign({}, state, {
        consultationId: action.payload,
      });
    default:
      return state;
  }
}
